import { type RootState } from '@/store';

export const isDrawerOpen = ({ drawer: { isDrawerOpen } }: RootState) =>
  isDrawerOpen;
export const drawerType = ({ drawer: { drawerType } }: RootState) => drawerType;
export const drawerData = ({ drawer: { drawerData } }: RootState) => drawerData;
